/**
 * Fertige Bilder einer Vorlage: Einzelbild zu einem Zeitpunkt, Standbild und
 * Standbild mit Richtungspfeilen für „Bewegung reduzieren“.
 */
import { fract } from './geometry.ts';
import { renderBody, renderSvg } from './render.ts';
import type { RenderOptions } from './render.ts';
import type { Scene } from './scene.ts';
import { withDefaults } from './template.ts';
import type { AnimationTemplate } from './template.ts';

/** Szene einer Vorlage zu einem Zeitpunkt (0 bis 1, wird umgebrochen). */
export function sceneAt(
  template: AnimationTemplate,
  values: Readonly<Record<string, unknown>>,
  time: number,
): Scene {
  const t = time >= 1 ? 1 : fract(time);
  return template.scene(withDefaults(template, values), t);
}

/** Standbild mit Hinweisen für reduzierte Bewegung. */
export function stillScene(template: AnimationTemplate, values: Readonly<Record<string, unknown>>): Scene {
  const complete = withDefaults(template, values);
  return [...template.scene(complete, template.stillTime), ...(template.hints?.(complete) ?? [])];
}

/** SVG einer Vorlage zu einem Zeitpunkt. */
export function frameSvg(
  template: AnimationTemplate,
  values: Readonly<Record<string, unknown>>,
  time: number,
  options: RenderOptions = {},
): string {
  return renderSvg(sceneAt(template, values, time), { title: template.title, ...options });
}

/** Inhalt (ohne svg-Element) einer Vorlage zu einem Zeitpunkt. */
export function frameBody(
  template: AnimationTemplate,
  values: Readonly<Record<string, unknown>>,
  time: number,
  options: RenderOptions = {},
): string {
  return renderBody(sceneAt(template, values, time), options);
}

/** SVG des Standbilds mit Richtungspfeilen. */
export function stillSvg(
  template: AnimationTemplate,
  values: Readonly<Record<string, unknown>>,
  options: RenderOptions = {},
): string {
  return renderSvg(stillScene(template, values), { title: template.title, ...options });
}
